// src/utils/inventory/costUtils.js
import { safeNumber } from "./dateUtils";

export const getCostForRequest = (requestRow, listingRow, quantityDelivered) => {
  // pre-computed total from allocation (quantity * listing cost per lb)
  const allocated = safeNumber(requestRow?.allocated_cost);
  if (allocated) return allocated;

  // fallback: listing.cost is per-lb rate, multiply by delivered qty
  const perLb = safeNumber(listingRow?.cost);
  if (perLb) return perLb * quantityDelivered;

  return 0;
};
